<template>
    <div class="page">
        <div class="batch-btns">
            <div>
                <el-button type="primary" size="medium" @click="onBatchAdd">批量添加标签</el-button>
                <el-popconfirm
                    title="确定批量删除吗？"
                    @confirm="onBatchDel"
                >
                    <el-button slot="reference" type="danger" size="medium">批量删除标签</el-button>
                </el-popconfirm>
                <el-button-group>
                    <el-button type="primary" :loading="is_loading" size="medium" @click="createBlockPlanarGraph">生成封面图</el-button>
                    <el-button type="primary" size="medium" :disabled="!block_planar_graph" @click="previewBlockPlanarGraph">预览</el-button>
                </el-button-group>
            </div>
            <el-button type="primary" size="medium" @click="addLocation">确认提交</el-button>
        </div>
        <div class="editor">
            <div class="preivew">
                <img v-if="image_url" :src="image_url" />
                <vue-drag-resize
                    :isActive="false"
                    :z="999"
                    :isResizable="false"
                    :isDraggable="item.isDraggable"
                    :parentLimitation="true"
                    :w="1"
                    :h="1"
                    :x="item.x_coordinate * 1"
                    :y="item.y_coordinate * 1"
                    :id="item.id"
                    @dragstop="onDragstop"
                    v-for="item in tags" :key="`tags-${item.id}`"
                >
                    <div class="tags-item">
                        <div class="tags-item--inner">{{ item.block }}</div>
                        <div class="tags-item--arrow"></div>
                    </div>
                </vue-drag-resize>
                <vue-drag-resize
                    :isActive="false"
                    :z="999"
                    :isResizable="false"
                    :parentLimitation="true"
                    :w="1"
                    :h="1"
                    :x="location_left"
                    :y="location_top"
                    @dragstop="onLocaitionDragstop"
                >
                    <div class="center_coordinate">
                        <el-tooltip class="item" effect="dark" content="用于前端总平缩略图作为中心焦点进行展示" placement="bottom">
                            <i class="el-icon-location location"></i>
                        </el-tooltip>
                    </div>
                </vue-drag-resize>
            </div>
            <div class="blocks">
                <div class="blocks-item" v-for="item in building_blocks" :key="`blocks-${item.id}`">
                    <div class="blocks-cell">{{ item.block }}</div>
                    <div class="blocks-cell">{{ item.status }}</div>
                    <div class="blocks-cell btns">
                        <el-popconfirm
                            title="确定删除吗？"
                            @confirm="confirmDel(item.id)"
                            v-if="item.added"
                        >
                            <el-button slot="reference" type="danger" size="medium">删除标签</el-button>
                        </el-popconfirm>
                        <el-button type="primary" size="medium" v-else @click="onAddTag(item.id)">添加标签</el-button>
                    </div>
                </div>
            </div>
        </div>

        <el-image 
            ref="cover_previewer"
            style="display: none;"
            :src="block_planar_graph" 
            :preview-src-list="[block_planar_graph]"
        />
    </div>
</template>
<script>
import VueDragResize from '@/components/vue-drag-resize'
import API from '@/service/planar_graph_editor'
let old_left = 0
let old_top = 0
const WIDTH = 750
const HEIGHT = 600
export default {
    components: {
        VueDragResize
    },
    beforeRouteEnter (to, from, next) {
        const { id } = to.params
        const { planar_graph_image_id } =  to.query
        next(vm => {
            vm.building_id = id
            vm.planar_graph_image_id = planar_graph_image_id
            vm.getBuildingBlocks(id, planar_graph_image_id)
        })
    },
    data () {
        return {
            building_id: '',
            planar_graph_image_id: '',
            block_planar_graph: null,
            image_url: '',
            building_blocks: [],
            tags: [],
            width: 0,
            height: 0,
            top: 0,
            left: 0,
            visible: false,
            is_loading: false,
            location_left: 0,
            location_top: 0
        }
    },
    mounted () {
    },
    methods: {
        async getBuildingBlocks (id, planar_graph_image_id) {
            try {
                const { data } = await API.getBuildingBlocks(id, planar_graph_image_id)
                const { items, image_url, block_planar_graph, center_coordinate } = data
                this.initCenter(center_coordinate)
                this.block_planar_graph = block_planar_graph?.url
                this.tags = items.filter(item => item.x_coordinate !== null && item.y_coordinate !== null).map(item => ({
                    ...item,
                    isDraggable: true
                }))
                this.building_blocks = items.map(item => ({
                    ...item,
                    added: item.x_coordinate !== null && item.y_coordinate !== null
                }))
                this.image_url = `${image_url}?x-oss-process=image/resize,m_pad,w_750,h_600`
            } catch (error) {
                console.log(error)
            }
        },
        onBatchAdd() {
            old_left = 0
            old_top = 0
            this.tags = this.tags.map(item => ({
                ...item,
                isDraggable: true
            }))
            const unadded_blocks = this.building_blocks.filter(item => !item.added)
            unadded_blocks.forEach(item => {
                this.tags.push(item)
            })
            this.building_blocks = this.building_blocks.map(item => {
                item.added = true
                return item
            })
        },
        onBatchDel() {
            this.tags = []
            this.building_blocks = this.building_blocks.map(item => {
                if (item.added) {
                    return{
                        ...item,
                        x_coordinate: null,
                        y_coordinate: null,
                        added: false
                    }
                }
                return item
            })
        },
        onAddTag(id) {
            old_left = 0
            old_top = 0
            this.tags = this.tags.map(item => ({
                ...item,
                isDraggable: true
            }))
            this.tags.push(this.building_blocks.filter(item => item.id === id)[0])
            this.building_blocks = this.building_blocks.map(item => {
                if (id == item.id) {
                    return {
                        ...item,
                        added: true
                    }
                }
                return item
            })
        },
        confirmDel(id) {
            this.tags = this.tags.filter(item => item.id !== id)
            this.building_blocks = this.building_blocks.map(item => {
                if (id == item.id) {
                    return {
                        ...item,
                        added: false,
                        x_coordinate: null,
                        y_coordinate: null
                    }
                }
                return item
            })
        },
        onDragstop({ left, top }, id) {
            if (old_left !== left || old_top !== top) {
                old_left = left
                old_top = top
                this.tags = this.tags.map(item => {
                    if (id == item.id) {
                        return {
                            ...item,
                            x_coordinate: left,
                            y_coordinate: top,
                        }
                    }
                    return item
                })
                this.building_blocks.forEach(item => {
                    if(id == item.id){
                        item.x_coordinate = left
                        item.y_coordinate = top
                    }
                })
                console.log({ left, top }, id)
            }
        },
        createBlockPlanarGraph() {
            this.is_loading = true
            API.createBlockPlanarGraph(this.building_id, this.planar_graph_image_id)
                .then(() => {
                    this.$message({
                        message: '结果可能存在延迟，请一分钟后查看生成结果！',
                        type: 'success'
                    })
                })
                .catch(err => {
                    console.log(err)
                    this.$message.error('生成失败，请稍后再试！')
                })
                .finally(() => this.is_loading = false)
        },
        previewBlockPlanarGraph() {
            this.$refs.cover_previewer.showViewer = true
        },
        initCenter(center_coordinate) {
            if(!center_coordinate) {
               this.location_left = WIDTH / 2
                this.location_top = HEIGHT / 2 
            }else {
                const [x, y] = center_coordinate.split(',')
                this.location_left = x
                this.location_top = y
            }
        },
        onLocaitionDragstop({ left, top }) {
            this.location_left = left
            this.location_top = top
        },
        addLocation() {
            const location = `${this.location_left},${this.location_top}`
            const planar_graph_tags = this.building_blocks.map(item => {
                const { id, x_coordinate, y_coordinate } = item
                return { id, x_coordinate, y_coordinate }
            })
            Promise.all([
                API.updateBatchCoordinate(this.building_id, { building_blocks: planar_graph_tags }),
                API.addCenterCoordinate(this.building_id, this.planar_graph_image_id, location)
            ]).then(() => {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
            }).catch(err => {
                console.log(err)
                this.$message.error('提交失败，请稍后再试！')
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.page {
    display: flex;
    height: calc(100vh - 108px);
    width: 100%;
    padding: 24px 0;
    align-items: center;
    flex-direction: column;
    overflow: auto;
}
.editor {
    width: 750px;
    background-color: #fff;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    .vdr.active:before {
        outline: none;
    }
}

.preivew {
    width: 100%;
    height: 600px;
    background-color: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    > img {
        max-width: 100%;
        max-height: 100%;
    }
}

.blocks {
    width: 100%;
}

.blocks-item {
    display: flex;
}

.blocks-cell {
    flex: 1;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:nth-of-type(3) {
        flex-grow: 2
    }
}

.tags,
.ice-anchor {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    z-index: 9;
}

.ice-anchor-point-placeholder {
    background-color: rgba(0, 0, 0, 0.5);
    height: 22px;
    width: 22px;
    color: #fff;
    font-size: 12px;
    line-height: 22px;
    text-align: center;
    border-radius: 50%;
}

.tags {
    z-index: 8;
}

.tags-item {
    position: absolute;
}

.tags-item--inner {
    white-space: nowrap;
    background: rgba(255,255,255,0.80);
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.20);
    border-radius: 14px;
    line-height: 28px;
    padding: 0 8px;
    position: absolute;
    bottom: 7px;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 12px;
    color: #333;
}
.tags-item--arrow {
    width: 12px;
    height: 7px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    background: url(../../assets/img/tag-arrow-down.png) no-repeat center;
    background-size: 100% 100%;
}
.tags-item--ref {
    position: absolute;
    left: 0;
    bottom: 28px;
}

.batch-btns {
    width: 750px;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    > div > * {
        margin-right: 16px;
    }
}
.location {
    color: #00B08D;
    font-size: 30px;
}
</style>
